module.exports = __webpack_public_path__ + "static/media/block-img-three.6e563c3c.svg";